<template>
    <div id="todo-app" class="border border-solid d-theme-border-grey-light rounded relative overflow-hidden">
        <vue-headful :title="$t('students-list')" />

        <vs-sidebar class="items-no-padding" parent="#todo-app" :click-not-close="clickNotClose" :hidden-background="clickNotClose" v-model="isSidebarActive">
            <!-- ФИЛЬТРЫ -->
            <ListFilters :sidebarToggle="toggleSidebar" ref="ListFilters" @closesidebar="toggleSidebar" :itemHandler="infiniteHandle" />
        </vs-sidebar>

        <div :class="{'sidebar-spacer': clickNotClose}" class="no-scroll-content border border-r-0 border-b-0 border-t-0 border-solid d-theme-border-grey-light no-scroll-content">

            <!-- Поиск -->
            <div class="flex border d-theme-dark-bg items-center">
                <feather-icon class="md:inline-flex lg:hidden ml-4 mr-4 cursor-pointer" icon="MenuIcon" @click.stop="toggleSidebar(true)"/>

                <!-- Строка поиска по ФИО -->
                <vx-input-group class="w-full">
                    <vs-input
                        icon-no-border
                        icon="icon-search"
                        size="large"
                        :maxlength="inputMaxLimit"
                        icon-pack="feather"
                        :placeholder="$t('name_of_student')"
                        :value="searchQuery"
                        @input="studentSearch"
                        class="vs-input-no-border vs-input-no-shdow-focus w-full" />

                    <template slot="append">
                        <div class="append-text btn-addon">
                            <vs-button
                                @click="clearSearch()"
                                :disabled="clearSearchDisabled"
                                color="dark"
                                type="flat"
                                class="rounded"
                                icon-pack="feather"
                                icon="icon-x">
                            </vs-button>
                        </div>
                    </template>
                </vx-input-group>
            </div>

            <!-- список студентов -->
            <component
                :is="'VuePerfectScrollbar'"
                class="infinite_scroll_wrapper"
                ref="listScroll"
                :settings="settings"
                :key="$vs.rtl"
                @ps-y-reach-end="infiniteHandle">

                    <ul v-if="studentList.length">
                        <li
                            class="todo_todo-item"
                            v-for="(item, index) in studentList"
                            :key="`d_${index}`"
                            :style="[{transitionDelay: (index * 0.1) + 's'}]">

                                <ListItem :item="item" />

                        </li>
                    </ul>

                    <!-- Выводим сообщение если данных нет -->
                    <div class="mt-4 ml-5 mr-5" v-if="emptyMessage">
                        <vs-alert active="true">
                            {{$t('no_data_text')}}
                        </vs-alert>
                    </div>

                <!-- В этот див выводил лоадер -->
                <div id="infinite_loader" class="vs-con-loading__container"></div>
            </component>
        </div>
    </div>
</template>

<script>
import studentList from '@/store/modules/student_list.js'
import ListFilters from './ListFilters.vue'
import ListItem from './ListItem.vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import Filters from '@/pages/Home/ListGlobalComponents/Filters'
import { mapActions, mapGetters } from 'vuex'

// Создаем переменную таймера глобально
let searchId;

export default {
    data() {
        return {
            // products: [],
            itemsPerPage: 4,
            isMounted: false,
            isSidebarActive: true,
            loading: false,
            emptyMessage: false,
            clickNotClose: true,
            inputMaxLimit: 35,
            settings: {
                maxScrollbarLength: 60,
                wheelSpeed: 0.60
            }
        };
    },
    components: {
        ListFilters,
        VuePerfectScrollbar,
        ListItem
    },
    watch: {
        windowWidth () {
            this.setSidebarWidth()
        }
    },
    computed: {
        ...mapGetters({
            studentList: 'student_list/getStudentList'
        }),
        windowWidth() { return this.$store.state.windowWidth },
        infiniteStatus: {
            get() {
                return this.$store.state.student_list.infiniteStatus
            },
            set(value) {
                this.$store.commit("student_list/SET_INF_STATUS", value)
            }
        },
        page: {
            get() {
                return this.$store.state.student_list.page
            },
            set(value) {
                this.$store.commit("student_list/SET_PAGE", value)
            }
        },
        searchQuery: {
            get () {
                return this.$route.query.fullname
            },
            set (val) {
                this.$store.commit('student_list/SET_SEARCH_QUERY', val)
            }
        },
        clearSearchDisabled() {
            // Делаем активной/не активной кнопку стереть запрос на фио пользователя
            if(this.$route.query['fullname']) return false
            else return true
        }
    },
    created: function() {
        // Регистрируем стор
        if(!this.$store.hasModule('student_list'))
            this.$store.registerModule('student_list', studentList)
        this.setSidebarWidth()
        this.searchAggregate()
    },
    destroyed () {
        // Если покудаем текущий компонент, удаляем стор
        // Из-за этой строки при смене языка выпадала ошибка "[vuex] unknown getter: student_list/getStudentList"
        this.$store.unregisterModule('student_list')
    },
    methods: {
        ...mapActions({
            fetchStudentList: 'student_list/fetchStudentList'
        }),
        clearSearch() {
            // Стираем строку запроса фио
            let query = Object.assign({}, this.$route.query)

            if(Object.keys(this.$route.query).includes('fullname')) {
                this.searchQuery = ''
                delete query['fullname']
                this.$router.push({query})
                this.$store.commit('student_list/CLEAR_STUDENT_LIST')
                this.infiniteHandle({update:true})
            }
        },
        studentSearch(e) {
            if (String(e).length <= this.inputMaxLimit) {
                this.searchQuery = e

                // Очищаем таймер
                clearTimeout(searchId);

                // Создаем таймер при завершении которого отправляем запрос к серверу
                searchId = setTimeout(() => {

                    let query = Object.assign({}, this.$route.query)

                    // Подменяем query в роуте на введенные в строку для поиска данные, проверяем что введенные данные не пустые
                    if(e.length > 0) {
                        query['fullname'] = e
                    } else if(Object.keys(this.$route.query).includes('fullname')) {
                        delete query['fullname']
                    }

                    this.$router.push({query})
                    this.$store.commit('student_list/CLEAR_STUDENT_LIST')
                    this.infiniteHandle({update:true})
                }, 0);
            }
        },
        searchAggregate() {
            // Если в строке браузера есть ключ fullname то подставляем от туда данные в поле поиска
            if(Object.keys(this.$route.query).includes('fullname')){
                if(this.$route.query.fullname.length <= this.inputMaxLimit)
                    this.searchQuery = this.$route.query.fullname
                else {
                    let query = Object.assign({}, this.$route.query)
                    delete query['fullname']
                    this.$router.push({query})
                }
            }
        },
        infiniteHandle({update = false}) {
            // Если update = true запрашиваем список заного с новыми параметрами
            if(update) {
                this.infiniteStatus = true
                this.page = 0
            }

            // Запрашщиваем список пользователей
            this.studentListHandler()
        },
        async studentListHandler() {
            if(!this.loading && this.infiniteStatus) {
                this.loading = true
                this.emptyMessage = false
                this.$nextTick(() => {
                    this.$vs.loading({
                        container: '#infinite_loader',
                        scale: 0.6
                    })
                })

                try {
                    this.page = this.page+1
                    const res = await this.fetchStudentList({page: this.page, route: this.$route})

                    // Если на первой странице данных нет вообще, выводим сообщение
                    if(!res || this.page === 1 && !res.results.length) this.emptyMessage = true

                    // Если запросили последнюю страницу, меняем статус инфинити скролла
                    if(!res || !res.next) this.infiniteStatus = false
                } catch({detail}) {
                    this.$vs.notify({
                        text: this.$t('error'),
                        color: 'danger',
                    })
                } finally {
                    this.loading = false
                    this.$vs.loading.close('#infinite_loader > .con-vs-loading')
                }
            }
        },
        toggleSidebar (value = false) {
            // Функция открытия sidebar с фильтрами для моб устройств
            if (!value && this.clickNotClose) return
            this.isSidebarActive = value
        },
        setSidebarWidth() {
            if (this.windowWidth < 992) {
                this.isSidebarActive = this.clickNotClose = false
            } else {
                this.isSidebarActive = this.clickNotClose = true
            }
        }
    }
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/todo.scss";
.emc__actions{
    .con-vs-tabs{
        padding-bottom: 2px;
        width: auto;
    }
    .con-slot-tabs{
        display: none;
    }
}
.emc_list_tabs{
    .con-ul-tabs{
        display: none;
    }
    .vs-tabs--content{
        padding: 0px;
    }
}
.filters_scroll_area{
    position: relative;
    width: 100%;
    margin: auto;
    &.aside_scroll_teacher{
        height: calc(100% - 67px);
    }
    &:not(.aside_scroll_teacher){
        height: 100%;
    }
}
.infinite_scroll_wrapper{
    margin: auto;
    position: relative;
    width: 100%;
    height: calc(100% - 50px);
    .infinite_alert{
        padding-left: 15px;
        padding-right: 15px;
        margin-top: 10px;
        text-align: center;
    }
}
#infinite_loader{
    padding: 20px 0;
    .con-vs-loading{
        background: transparent;
    }
}
.full-vs-sidebar{
    .mail-sidebar-content{
        background-color: rgb(248, 248, 248) !important;
    }
    .email-header{
        box-shadow: 0 4px 6px rgba(0,0,0,.04);
        border-bottom: 1px solid #eee;
    }
}
</style>
